export default {"src":"/_next/static/media/fx-logo.83a2aa4c.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};